import type { NodeRef } from "../engine/types.ts";
import type { CosmosData, GalaxyMeta } from "../parser/types.ts";

const KEY = "cosmos.favorites.v1";

export interface FavoritesCallbacks {
  resolve: (id: string) => NodeRef | null;
  onNavigate: (id: string) => void;
}

/** Favoritos persistentes (localStorage) + painel lateral. */
export class Favorites {
  private set = new Set<string>();
  private el!: HTMLElement;
  private listEl!: HTMLElement;

  constructor(private data: CosmosData, private cb: FavoritesCallbacks) {
    try {
      const r = localStorage.getItem(KEY);
      if (r) for (const id of JSON.parse(r) as string[]) this.set.add(id);
    } catch { /* ignore */ }
  }
  setData(d: CosmosData) { this.data = d; }
  has(id: string | null): boolean { return !!id && this.set.has(id); }
  toggle(id: string | null) {
    if (!id) return;
    if (this.set.has(id)) this.set.delete(id);
    else this.set.add(id);
    this.persist();
    this.render();
  }
  private persist() {
    try { localStorage.setItem(KEY, JSON.stringify([...this.set])); } catch { /* ignore */ }
  }

  mount(root: HTMLElement) {
    root.insertAdjacentHTML(
      "beforeend",
      `<div id="favorites" class="panel"><div class="fav-head">★ Favoritos</div><div id="fav-list"></div></div>`,
    );
    this.el = root.querySelector("#favorites") as HTMLElement;
    this.listEl = root.querySelector("#fav-list") as HTMLElement;
    this.listEl.addEventListener("click", (e) => {
      const t = e.target as HTMLElement;
      const rm = t.closest("[data-rm]") as HTMLElement | null;
      if (rm?.dataset.rm) { this.toggle(rm.dataset.rm); return; }
      const go = t.closest("[data-id]") as HTMLElement | null;
      if (go?.dataset.id) this.cb.onNavigate(go.dataset.id);
    });
    this.render();
  }

  private galColor(g: string): string {
    return (this.data.gal as Record<string, GalaxyMeta>)[g]?.color ?? "#8893ad";
  }
  render() {
    const refs = [...this.set].map((id) => this.cb.resolve(id)).filter((r): r is NodeRef => !!r);
    this.el.classList.toggle("show", refs.length > 0);
    this.listEl.innerHTML = refs
      .map((r) =>
        `<div class="fav-item" data-id="${esc(r.id)}"><span class="d" style="background:${this.galColor(r.gal)}"></span><span class="fav-label">${esc(r.label)}</span><button class="fav-rm" data-rm="${esc(r.id)}" title="remover">×</button></div>`,
      )
      .join("");
  }
}

function esc(s: string): string {
  return s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c] as string));
}
